import React, { useCallback, useEffect, useState } from 'react';
import { useService } from '../../services/services';
import { route } from '../../services/utils';
import { TOKENS_VIEW } from '../../router/routes';
import Form, { SubmitType } from '../../components/form';
import Group from '../../components/form/elements/group';
import Text from '../../components/form/elements/text';
import Link from '../../components/form/elements/link';
import { useObservableState } from 'observable-hooks';
import Token from '../../interfaces/token';
import { useHistory, useParams } from 'react-router';
import Readonly from '../../components/form/elements/readonly';
import Button from '../../components/form/elements/button';
import Date from '../../components/form/elements/date';
import * as yup from 'yup';

export default function ApiTokenEdit() {
  const { id } = useParams<{ id: string }>();
  const { tokenService } = useService();
  const history = useHistory();

  const [body] = useState(() => [
    Group([
      Text('name', 'pages.tokens.name'),
      Readonly([
        Date('last_used_at', 'pages.tokens.last_used_at'),
        Date('created_at', 'pages.tokens.created_at'),
        Date('updated_at', 'pages.tokens.updated_at'),
      ]),
    ]),
  ]);
  const [footer] = useState(() => [
    Button('save'),
    Link(route(TOKENS_VIEW, { id }), 'cancel'),
  ]);

  const [token] = useObservableState<Token>(() => tokenService.show(id), null);

  useEffect(() => {
    if (token && token.not_editable) {
      history.push(route(TOKENS_VIEW, { id }));
    }
  }, [history, token, id]);

  const submit = useCallback<SubmitType<Token>>(
    (form) => [
      tokenService.update(id, form),
      () => history.push(route(TOKENS_VIEW, { id })),
    ],
    [tokenService, id, history]
  );

  return (
    <Form
      title={token?.name ?? 'pages.tokens.edit-token'}
      backTo={route(TOKENS_VIEW, { id })}
      mode="edit"
      body={body}
      footer={footer}
      values={token}
      schema={tokenSchema}
      submit={submit}
    />
  );
}

const tokenSchema = yup.object().shape({
  name: yup.string().max(255).required(),
});
